S.footerNav =
  {
      elements: {
          $link: null,
      },

      init()
      {
          if (window.location.href.indexOf('impressum') > -1)
          {
              this.elements.$link.each((index, item) =>
              {
                  if ($(item).attr('href').indexOf('#CCM.openWidget') > -1)
                  {
                      $(item).remove();
                  }
              });
          }

          if (window.location.href.indexOf('datenschutz') > -1)
          {
              this.elements.$link.each((index, item) =>
              {
                  if ($(item).attr('href').indexOf('#CCM.openWidget') > -1)
                  {
                      $(item).remove();
                  }
              });
          }

          this.elements.$link.each((index, item) =>
          {
              if ($(item).attr('href').indexOf('#CCM.openWidget') > -1)
              {
                  $(item).attr('href', '#');
                  $(item).attr('onclick', 'CCM.openWidget();return false;');
              }
          });
      },
  };
